const getDisplayName = Component =>
  Component?.displayName || Component?.name || 'NoNameComponent';

export default getDisplayName;
